import { lazy } from 'react';

const ErrorPage = lazy(() => import('./ErrorPage'));

export { ErrorPage };
